/**
 * 현재까지 읽은 페이지를 리턴합니다. (현재 페이지 + 이전 챕터들의 모든 페이지)
 */
export function getPageSubtotalCount({
  currentPage,
  isViewerEnd,
  chapterPageCountList,
  currentChapterId,
}: {
  currentPage: number;
  isViewerEnd?: boolean;
  chapterPageCountList?: number[];
  currentChapterId: number;
}) {
  const subtotalCount =
    chapterPageCountList
      ?.filter((_, index) => index < currentChapterId)
      .reduce((prev, current) => prev + current, 0) || 0;
  return subtotalCount + (isViewerEnd ? 0 : currentPage);
}
